module.exports = __webpack_public_path__ + "static/media/logo-animado-small.b1ea2f1c.gif";